// extracted by mini-css-extract-plugin
export default {"wrapper":"FullscreenWrapper_wrapper__C9O5Q","fullscreen":"FullscreenWrapper_fullscreen__kCobv","button":"FullscreenWrapper_button__W2rOc"};